import {management} from '../../../../'

import {VolumeRepository} from "../../../infra/knex/repositories/volume"

import {DeleteVolumeByIntervalUseCase} from './deleteVolumeByInterval'


export const deleteVolumeByInterval=()=>{
  const repository= new VolumeRepository(management)

  const deleteVolume= new DeleteVolumeByIntervalUseCase(repository)

  return deleteVolume
}
